import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { userHasBookings } from 'src/api/userService';

export const useGetUserHasBookings = (userLoggedIn: boolean) => {
    const query = useQuery<boolean, AxiosError>({
        enabled: userLoggedIn,
        queryKey: ['userHasBookings'],
        queryFn: () => userHasBookings(),
    });

    return {
        ...query,
    };
};
